import { useRef } from 'react'
import { observer } from 'mobx-react-lite'

import { Modal } from 'almanac-ui/Modal'
import useShareSheetV2 from 'hooks/useShareSheetV2'
import { RecipientsSelectorValueType } from 'types'
import { ContentComposer } from 'components/ShareSheet/ContentComposer/ContentComposer'
import { RecipientSelector } from './RecipientSelector'
import { ShareSheetProps } from './Types'
import Styles from './ShareSheet.module.scss'
import { ShareSheetScreen, useShareSheetContext } from 'common/ShareSheetV2/ShareSheetV2'
import { Button } from 'blaze-ui/Button/Button'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'

export const InviteCollaborators = observer(({ file }: ShareSheetProps) => {
  const { inviteMessage, setShareSheet, inviteUsers, recipients, isSubmitting } = useShareSheetV2(file)
  const contentRef = useRef<any>()
  const { setScreen } = useShareSheetContext()

  const submit = () => {
    if (recipients.some((rec) => rec.type === RecipientsSelectorValueType.Email)) {
      setScreen(ShareSheetScreen.ShowInviteToWorkspaceScreen)
      setShareSheet({ showInviteToWorkspaceScreen: true })

      return
    }

    inviteUsers()
  }

  return (
    <>
      <Modal.Header title="Invite collaborators" />
      <div className={Styles.content}>
        <RecipientSelector file={file} showLabel className={Styles.alignTop} />
        <div className={Styles.messageWrapper}>
          <ContentComposer
            ref={contentRef}
            content={inviteMessage}
            onChange={(inviteMessage) => setShareSheet({ inviteMessage })}
            size="md"
          />
        </div>
        <ResponsiveDesign.Mobile>
          <div className={Styles.sendInviteFooter}>
            <Button size="lg" onPress={submit} fullWidth isDisabled={isSubmitting}>
              Send Invite
            </Button>
          </div>
        </ResponsiveDesign.Mobile>
      </div>
      <ResponsiveDesign.Desktop>
        <Modal.Footer>
          <Modal.FooterContent slot="left">
            <Button
              size="lg"
              variant="tertiary"
              onPress={() => {
                setShareSheet({ recipients: [], inviteMessage: '' })
              }}
              isDisabled={isSubmitting}
            >
              Back
            </Button>
          </Modal.FooterContent>
          <Modal.FooterContent slot="right">
            <Button size="lg" onPress={submit} isDisabled={isSubmitting}>
              Send Invite
            </Button>
          </Modal.FooterContent>
        </Modal.Footer>
      </ResponsiveDesign.Desktop>
    </>
  )
})
